import React, { useState } from 'react'
import UserContext from '../context/UserContext'

interface Props {
    children: JSX.Element[] | JSX.Element
}

export default function Layout({ children }: Props) {
    const [walletAddress, setWalletAddress] = useState('')

    const handleContextWallet = (wallet: string) => {
        setWalletAddress(wallet)
    }

    return (
        <UserContext.Provider value={{ walletAddress, handleContextWallet }}>
            {children}
        </UserContext.Provider>
    )
}
